var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.471 7.53735C12.0775 7.53735 8.52051 11.0982 8.52051 15.4879C8.52051 19.8814 12.0813 23.4384 16.471 23.4384C20.8646 23.4384 24.4215 19.8776 24.4215 15.4879C24.4215 11.0943 20.8607 7.53735 16.471 7.53735ZM16.471 20.6483C13.619 20.6483 11.3105 18.3386 11.3105 15.4879C11.3105 12.6371 13.6203 10.3274 16.471 10.3274C19.3217 10.3274 21.6315 12.6371 21.6315 15.4879C21.6328 18.3386 19.323 20.6483 16.471 20.6483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8524 0.100261C20.0016 -0.0327216 12.9407 -0.0262661 10.0874 0.100261C7.58008 0.21775 5.36844 0.82327 3.58545 2.60626C0.605619 5.58609 0.98649 9.60138 0.98649 15.49C0.98649 21.5168 0.650807 25.4392 3.58545 28.3738C6.5769 31.364 10.6503 30.9728 16.4692 30.9728C22.4392 30.9728 24.4998 30.9766 26.6107 30.1594C29.4808 29.0452 31.6472 26.4798 31.859 21.8719C31.9933 19.0199 31.9855 11.9602 31.859 9.10689C31.6033 3.66754 28.6842 0.368807 22.8524 0.100261ZM27.3647 26.4023C25.4113 28.3557 22.7013 28.1814 16.4318 28.1814C9.97633 28.1814 7.3877 28.277 5.49884 26.3829C3.32336 24.2178 3.71714 20.7409 3.71714 15.4694C3.71714 8.33611 2.98509 3.19887 10.1442 2.8322C11.789 2.7741 12.2732 2.75474 16.4137 2.75474L16.4718 2.79347C23.352 2.79347 28.75 2.07304 29.0741 9.23084C29.1477 10.8641 29.1645 11.3547 29.1645 15.4887C29.1632 21.8693 29.2846 24.4734 27.3647 26.4023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7358 9.08147C25.7619 9.08147 26.5937 8.24967 26.5937 7.2236C26.5937 6.19752 25.7619 5.36572 24.7358 5.36572C23.7097 5.36572 22.8779 6.19752 22.8779 7.2236C22.8779 8.24967 23.7097 9.08147 24.7358 9.08147Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9861,
    height: 30.9861,
    fill: "white",
    transform: "translate(0.972656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.30af4eba7abfb30997f2cc36e383412b.svg";
export { ForwardRef as ReactComponent };